<template>
  <v-container>
    <h1>
      <v-icon class="iconHeader">mdi-chart-bar</v-icon>
      {{ $t("views.statistics.header") }}
    </h1>
  </v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>